import classNames from "classnames";

interface Props {
	children: React.ReactNode | React.ReactNode[];
	className?: string;
}

export default function PageContent({ children, className }: Props) {
	return (
		<section
			className={classNames(
				"w-full even:bg-background-body odd:bg-background flex flex-col",
				className
			)}
		>
			<div className="max-w-site mx-auto w-full flex-1 flex flex-col">
				{children}
			</div>
		</section>
	);
}
